import * as React from 'react'

import omit from 'lodash-es/omit'

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string
  capture?: boolean | undefined // TODO: Remove this once its not needed, this was added because of this error "Types of property 'capture' are incompatible."
}

interface IState {
  value?: string
}

class SearchBarInput extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      value: this.props.value
    }
  }

  public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    const value = nextProps.value
    if (value !== this.state.value) {
      this.setState({ value })
    }
  }

  public render() {
    const passProps = omit(this.props, [
      'type',
      'value',
      'onChange',
      'aria-label'
    ])

    return (
      <input
        type="search"
        value={this.state.value || ''}
        onChange={this.onChange.bind(this)}
        aria-label="search"
        {...passProps}
      />
    )
  }

  private onChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ value: event.target.value }, () => {
      if (this.props.onChange) {
        this.props.onChange(event)
      }
    })
  }
}

export default SearchBarInput
